import {sortByField} from '../helpers/utils'
import { getDrivers } from '../helpers/api'
import { paymentsDB, pluckDocs } from '../helpers/db'

const BATCH_DRIVER_UPDATE = 'users/BATCH_DRIVER_UPDATE'
const DRIVER_REQUEST_ONGOING = 'users/DRIVER_REQUEST_ONGOING'
const DRIVER_REQUEST_ENDED = 'users/DRIVER_REQUEST_ENDED'

const BATCH_CLIENT_UPDATE = 'users/BATCH_CLIENT_UPDATE'
const CLIENT_REQUEST_ONGOING = 'users/CLIENT_REQUEST_ONGOING'
const CLIENT_REQUEST_ENDED = 'users/CLIENT_REQUEST_ENDED'

const defaultState = {
  drivers: [],
  clients: [],
  requestOngoing: false,
  isClientRequestOngoing: false
}

export default (state = defaultState, {type, ...actionProps}) => {
  switch (type) {
    case BATCH_DRIVER_UPDATE:
      return {
        ...state,
        drivers: [...actionProps.data],
        requestOngoing: false
      }
    case DRIVER_REQUEST_ONGOING:
      return {
        ...state,
        requestOngoing: true
      }
    case DRIVER_REQUEST_ENDED:
      return {
        ...state,
        requestOngoing: false
      }
    case BATCH_CLIENT_UPDATE:
      return {
        ...state,
        clients: [...actionProps.data]
      }
    case CLIENT_REQUEST_ONGOING:
      return {
        ...state,
        isClientRequestOngoing: true
      }
    case CLIENT_REQUEST_ENDED:
      return {
        ...state,
        isClientRequestOngoing: false
      }
    default:
      return {
        ...state
      }
  }
}

/**
 * Fetch users with driver view
 */
export const fetchDrivers = () => (dispatch) => {
  dispatch({
    type: DRIVER_REQUEST_ONGOING
  })

  return getDrivers()
    .then((drivers) => {
      dispatch({
        type: BATCH_DRIVER_UPDATE,
        data: sortByField(drivers, 'fullName')
      })
    })
    .catch(() => {
      dispatch({
        type: DRIVER_REQUEST_ENDED
      })
    })
}

/**
 * Fetch clients
 */
export const fetchClients = () => (dispatch) => {
  dispatch({
    type: CLIENT_REQUEST_ONGOING
  })

  const opts = {
    startkey: 'client:',
    endkey: 'client:\uffff',
    include_docs: true
  }

  return paymentsDB.allDocs(opts)
    .then(pluckDocs)
    .then((clients) => {
      dispatch({
        type: BATCH_CLIENT_UPDATE,
        data: sortByField(clients, 'name')
      })
      dispatch({
        type: CLIENT_REQUEST_ENDED
      })
    })
    .catch(() => {
      dispatch({
        type: CLIENT_REQUEST_ENDED
      })
    })
}



// WEBPACK FOOTER //
// ./src/app/users-reducer.js